import { useNavigate } from 'react-router-dom';
import viewAllButtonImg from '../../../../img/view_all_button.png';

const ViewAllButton = () => {
    const navigate = useNavigate();
    return (
        <div>
        <a onClick={() => navigate("/user/photos")} style={{display: 'flex', justifyContent: 'center'}}>
            <img src={viewAllButtonImg} alt='[見る 1]' style={{ width: '80%', aspectRatio: '1 / 1' }}/>
        </a>
        {/* <a onClick={() => navigate("../communityGallery2")} style={{display: 'flex', justifyContent: 'center'}}>
            [見る 2]
        </a> */}
        </div>
    )
}

export default ViewAllButton;

// このコンポーネントは削除予定。
// スライドショー確認の為に残している。
